import { 
  LocationActionTypes, 
  Location, 
  LocationFlow,
  Coordinates
} from "./types";

// Action for successful user location retrieval
export const getUserLocationsSuccess = (locations: Location[]): LocationActionTypes => ({
  type: 'GET_USER_LOCATIONS_SUCCESS',
  payload: locations,
});

// Action for failed user location retrieval
export const getUserLocationsFailure = (error: string): LocationActionTypes => ({
  type: 'GET_USER_LOCATIONS_FAILURE',
  payload: error,
});

// Action to select a location
export const selectLocation = (location: Location | null): LocationActionTypes => ({
  type: 'SELECT_LOCATION',
  payload: location,
});

export const setUserLocationInputs = (inputs: LocationFlow): LocationActionTypes => ({
  type: 'SET_USER_LOCATION_INPUTS',
  payload: inputs
})

// Action for successful location creation
export const createLocationSuccess = (location: Location): LocationActionTypes => ({
  type: 'CREATE_LOCATION_SUCCESS',
  payload: location,
});

// Action for failed location creation
export const createLocationFailure = (error: string): LocationActionTypes => ({
  type: 'CREATE_LOCATION_FAILURE',
  payload: error,
});

// Action to toggle the create location modal
export const toggleCreateLocationModal = (): LocationActionTypes => ({
  type: 'TOGGLE_CREATE_LOCATION_MODAL',
});

export const setGeolocatedCoordinates = (coordinates: Coordinates): LocationActionTypes => ({
  type: 'SET_GEOLOCATED_COORDINATES',
  payload: coordinates
})
